export default "__VITE_ASSET__c8ae18c5__"